import styled from "styled-components";

export const ChatFooterInput = styled.input`
  && {
    ${((props) => props?.theme?.themeConfig?.chatFooter?.inputGroup?.input?.styles)}
  
    font-size: inherit;
  }
`;